import _ from 'underscore';

const MTCampaignTypeEnum = {
  Default: 1,
  Shopping: 2,
  DynamicSearchAds: 4,
  Audience: 8,
};

const MTCampaignStatus = {
  Suspended: 8,
  Active: 121,
  Deleted: 123,
  UserPaused: 124,
  BudgetPaused: 126,
  BudgetUserPaused: 127,
};

const MTAdGroupStatus = {
  CampaignUserPaused: 124,
  CampaignBudgetPaused: 126,
  CampaignBudgetUserPaused: 127,
  Draft: 140,
  Active: 141,
  Deleted: 143,
  Paused: 144,
  Expired: 150,
};

export function convertStringToEnumForCampaign(currentCampaign) {
  if (_.isEmpty(currentCampaign)) {
    return currentCampaign;
  }
  const campaign = _.clone(currentCampaign);
  campaign.CampaignType = MTCampaignTypeEnum[currentCampaign.CampaignType];
  campaign.Status = MTCampaignStatus[currentCampaign.Status];
  return campaign;
}

export function convertStringToEnumForAdGroup(currentAdGroup) {
  if (_.isEmpty(currentAdGroup)) {
    return currentAdGroup;
  }
  const adGroup = _.clone(currentAdGroup);
  adGroup.Status = MTAdGroupStatus[currentAdGroup.Status];
  return adGroup;
}
